import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
});

export const StyledConnectButton = styled(LoadingButton)(({ theme }) => ({
  position: 'absolute',
  top: '300px',
  color: '#fff',
  backgroundColor: '#2949f1',
  width: '68px',
  height: '46px',
  borderRadius: '23px',
  alignItems: 'center',
  padding: '10px',
  zIndex: 2,
  boxShadow: 'none',
  "& .MuiButton-startIcon": {
    margin: 0
  },
  '&:hover': {
    backgroundColor: '#0d1a8c',
  },
  '&.Mui-disabled': {
    backgroundColor: '#D7D7D7',
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: '#D7D7D7',
    }
  }
})); 